import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=673c14b0&scoped=true&"
import script from "./TeamRow.vue?vue&type=script&lang=js&"
export * from "./TeamRow.vue?vue&type=script&lang=js&"
import style0 from "./TeamRow.vue?vue&type=style&index=0&id=673c14b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c14b0",
  null
  
)

export default component.exports